module.exports = __webpack_public_path__ + "img/logo-small.dc135f0e.svg";